export const DEVICE_DISCONNECT = 'device-disconnect';
export const DEVICE_RECONNECT = 'device-reconnect';
